<template>
  <form @submit.prevent="validateAndSubmit" novalidate>
    <b-field
      :type="{ 'is-danger': errors.has('city') }"
      :message="errors.first('city')"
    >
      <b-select
        name="city"
        placeholder="Selecione a cidade"
        expanded
        v-model="user.city"
        v-validate="'required'"
        data-vv-as="cidade"
      >
        <option value="">Selecione a cidade...</option>
        <option
          v-for="option in cities"
          :value="option.value"
          :key="option.value"
        >
          {{ option.title }}
        </option>
      </b-select>
    </b-field>
    <b-field
      :type="{ 'is-danger': errors.has('name') }"
      :message="errors.first('name')"
    >
      <b-input
        name="name"
        v-model="user.name"
        type="text"
        placeholder="Razão social"
        v-validate="'required'"
        data-vv-as="name"
      />
    </b-field>
    <b-field
      :type="{ 'is-danger': errors.has('email') }"
      :message="errors.first('email')"
    >
      <b-input
        name="email"
        v-model="user.email"
        type="email"
        placeholder="E-mail"
        v-validate="'required|email'"
        novalidate
      />
    </b-field>
    <b-field
      :type="{ 'is-danger': errors.has('document') }"
      :message="errors.first('document')"
    >
      <b-input
        name="document"
        v-model="user.document"
        placeholder="CNPJ"
        v-validate="'required|document'"
        data-vv-as="CNPJ"
        v-cleave="masks.CNPJ"
        @input.native="cleaveRefresh"
      />
    </b-field>
    <b-button expanded native-type="submit" type="is-primary"
      >Continuar</b-button
    >
  </form>
</template>

<script>
import { cities } from "../../services/cityUtils";
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";

export default {
  data() {
    return {
      masks,
      cleaveRefresh,
      cities: cities,
      user: {
        city: null,
        name: null,
        email: null,
        document: null,
      },
    };
  },
  directives: {
    cleave,
  },
  methods: {
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("onConfirm", Object.assign({}, this.user));
        } else {
          this.$buefy.toast.open({
            message: "Verfique os campos marcados para continuar.",
            type: "is-danger",
          });
        }
      });
    },
  },
};
</script>
